import { useI18n } from "@/lib/i18n";

export default function LiveTicker({ markets = [] }) {
    const { t } = useI18n();
    const items = markets.length > 0 ? markets : [
        { title: "Loading live markets…", id: "skel" },
    ];
    const doubled = [...items, ...items];
    return (
        <div className="border-y border-p2w-line bg-p2w-surface/60 overflow-hidden" data-testid="live-ticker">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-stretch">
                <div className="flex items-center gap-2 pr-5 mr-5 border-r border-p2w-line py-3 shrink-0">
                    <span className="w-2 h-2 rounded-full bg-p2w-magenta animate-pulse-dot shadow-glow-magenta" />
                    <span className="text-[11px] uppercase tracking-[0.25em] font-sora font-bold text-p2w-magenta whitespace-nowrap">
                        {t("home.live_ticker_title")}
                    </span>
                </div>
                <div className="relative flex-1 overflow-hidden">
                    <div className="flex gap-10 whitespace-nowrap animate-marquee py-3 will-change-transform">
                        {doubled.map((m, i) => (
                            <div
                                key={`${m.id}-${i}`}
                                className="flex items-center gap-3 text-sm"
                            >
                                <span className="text-p2w-gray uppercase tracking-wider text-[10px] font-semibold">
                                    {m.category?.name || "Live"}
                                </span>
                                <span className="text-white/90">{m.title}</span>
                                <span className="font-sora font-bold text-p2w-green number-tabular">
                                    {m.total_pool ? Math.round(m.total_pool).toLocaleString("es-ES") : 0} pts
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
